import Api from 'utils/api';


const useInvoices = () => {
    return {
        findInvoices: Api.invoices.find,
        getInvoice: Api.invoices.get,
        generateForVoyage: Api.invoices.generate,
        paidInvoice: Api.invoices.paid,
        createInvoice: Api.invoices.create,
    }
};

export default useInvoices;
